module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_1000_2000.d682299f.png";